import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GaSideNavigationModule } from 'gain-lib/side-navigation';
import { ClientSharedModule } from 'gain-web/app/clients/client-shared/client-shared.module';
import { MaterialUIModule } from '../material-ui/material-ui.module';
import { MockPageContentComponent } from './mock-page-content/mock-page-content.component';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';

@NgModule({
  declarations: [
    MockPageContentComponent,
    SideNavigationComponent,
    TopNavigationComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GaSideNavigationModule,
    MaterialUIModule,
    RouterModule,
    ClientSharedModule,
  ],
  exports: [
    MockPageContentComponent,
    SideNavigationComponent,
    TopNavigationComponent,
  ],
})
export class LayoutNavigationModule {}
